<template>
	<div class="publish-comments" :class="[mode]">
		<BaseThemeUiModal name="comment" v-slot="{item: parentId}" :mask-closable="true">
			<div class="clear comment-form-container">
				<!-- <div class="pd-comments-title"><BaseCmsLabel code="comments" /></div> -->
				<!-- <div v-if="mode == 'pd'" class="pd-comments-intro"><BaseCmsLabel code="publish_comment_intro" /></div> -->
				<div class="cd-comments-intro"><BaseCmsLabel code="product_comment_intro" /></div>
				<div class="comment-form-inner">
					<FeedbackCommentsFormCustom :images="images" :video="video" class="form-comment form-animated-label" :parent-comment-id="parentId.parent_comment_id ? parentId.parent_comment_id : ''" v-slot="{fields, status, onReset}">
						<template v-if="!status?.success">
							<BaseFormField v-for="item in fields" :key="item.name" :item="item" v-slot="{errorMessage, floatingLabel}">
								<p v-if="item.name == 'image_1'" class="field comment-field comment-field-images" :class="['comment-field-' + item.name, {'ffl-floated': floatingLabel}]">
									<input type="file" :name="item.name" :id="item.name" multiple ref="imageInput" @change="handleImageChange">
									<label :for="item.name"><BaseCmsLabel code="field_add_photos" /><BaseCmsLabel code="field_add_photos_max" tag="span" /></label>
									<BaseCmsLabel code="field_add_photos_max_mb" class="field-s-note" tag="span" />
									<span class="uploaded-images" v-if="images.length">
										<span class="uploaded-images-items">
											<div v-for="(image, index) in images" :key="index">{{image.name}}</div>
										</span>
										<span class="uploaded-delete" @click="clearImages">Obriši fotografije</span>
									</span>
								</p>
								<p v-else-if="item.name == 'video'" class="field comment-field" :class="['comment-field-' + item.name, {'ffl-floated': floatingLabel}]">
									<input type="file" :name="item.name" :id="item.name" ref="videoInput" @change="(event) => {video = event.target.files?.[0]}">										
									<BaseCmsLabel tag="label" :for="item.name" code="video" />
									<BaseCmsLabel code="field_add_video_max_mb" class="field-s-note" tag="span" />

									<span class="uploaded-images" v-if="video.name">
										<span class="uploaded-images-items">
											{{ video.name }}
										</span>
										<span class="uploaded-delete" @click="clearVideo">Obriši video</span>
									</span>
								</p>								
								<BaseFormInput v-else-if="item.type == 'hidden'" />
								<p v-else-if="!item.name.includes('image')" class="field comment-field" :class="['comment-field-' + item.name, {'ffl-floated': floatingLabel, 'hidden': item.type == 'hidden'}]">
									<BaseFormInput :id="item.name" />
									<span v-if="item.name == 'rate'" class="label"><BaseCmsLabel code="your_rate" /></span>
									<label v-else :for="item.name"><BaseCmsLabel :code="'inquiry_' + item.name" :default="item.name" /></label>
									<span class="error" v-show="errorMessage" v-html="errorMessage" />								
								</p>
							</BaseFormField>
							<div class="buttons comment-button-cnt">
								<button class="btn btn-primary btn-send-comment" type="submit"><span><BaseCmsLabel code="send_comment" /></span></button>
								<BaseCmsLabel code="comment_form_note" class="comment-form-note" tag="div" />
							</div>
						</template>
						<div class="comment-success" v-if="status?.success">
							<div class="comment-success-message"><BaseCmsLabel code="comment_success" /></div>
							<div class="btn btn-primary btn-comment-new" @click="onReset"><span><BaseCmsLabel code="comment_add_new" /></span></div>
						</div>
					</FeedbackCommentsFormCustom>
				</div>
			</div>
		</BaseThemeUiModal>
	</div>
	

	<div id="comment-list" class="comment-list">
		<div v-if="(item.feedback_rate_widget?.rates_status || item.feedback_comment_widget?.comments_status) && item.feedback_rate_widget?.rates_votes > 0 && mode != 'pd'" class="comments-general-cnt">
			<div v-if="item.feedback_rate_widget?.rates" class="comments-general-rates-grade">
				<div class="comments-general-grade">{{parseFloat(item.feedback_rate_widget.rates).toFixed(2)}}</div>
				<FeedbackRates :rates="item.feedback_rate_widget.rates"/>
			</div>
			<div v-if="item.feedback_comment_widget?.comments_status == 2 && item.feedback_comment_widget?.comments > 0 || item.feedback_comment_widget?.comments_status >= 3" class="comments-general-counter" v-html="labels.get('comments_counter_label').replace('%c%', item.feedback_comment_widget?.comments)"></div>
			<BaseCmsLabel v-else code="no_comments" class="cd-comments-qty" tag="div" />
		</div>

		<div class="comment-filters-sections">
			<template v-if="item.feedback_comment_widget.comments > 1 && mode != 'pd'">
				<div v-if="bestReviewedComment">
					<BaseCmsLabel code="best_reviewed_commet" class="comments-titles" tag="div" />
					<FeedbackCommentEntry :key="bestReviewedComment.id" :item="bestReviewedComment" class="cd-comment cd-best-comment" />
				</div>
			</template>

			<div class="btn btn-green comment-button" @click="modal.open('comment')"><BaseCmsLabel code="comment_button_label" tag="span" /></div>
			
			<template v-if="item.feedback_comment_widget.comments > 1 && mode != 'pd'">
				<div class="comments-filters" :class="{loading: loading}">
					<UiLoader color="black" v-if="loading" />
					<div v-for="(filter, key) in filters" :key="key" @click="toggleFilter(key)" class="comment-filter" :class="['filter-'+ key, {active: filter.active}]">
						<span class="comment-filter-title">{{filter.label}}</span>
						<span class="slider"></span>
					</div>
					
					<select v-model="selectedSort" @change="sort">
						<option value="" selected disabled>Sortiranje</option>
						<option value="new">Najnovije</option>
						<option value="old">Najstarije</option>
						<option value="rate_up">Najviša ocjena</option>
						<option value="rate_down">Najniža ocjena</option>
					</select>
				</div>
			</template>
		</div>

		<BaseFeedbackComments v-if="mode == 'pd'" :items="item?.feedback_comment_widget?.items ? item?.feedback_comment_widget?.items : {}" sort="desc" v-slot="{items: commentsPublish}">
			<div class="comments-titles comments-titles-other"><BaseCmsLabel code="other_comments" /></div>
			<div v-if="item.feedback_comment_widget.comments > 0" class="comment-list-cnt">
				<FeedbackCommentEntry v-for="comment in commentsPublish" :key="comment.id" :item="comment" class="cd-comment" :mode="[mode]" />	
			</div>
			<div v-else class="no-comments"><BaseCmsLabel code="no_comments" /></div>
		</BaseFeedbackComments>
		<template v-else>
			<div class="comments-titles comments-titles-other"><BaseCmsLabel code="other_comments" /></div>
			<div v-if="item.feedback_comment_widget.comments > 0" class="comment-list-cnt">
				<FeedbackCommentEntry v-for="comment in comments" :key="comment.id" :item="comment" class="cd-comment" />
				<button class="comments-load-more" type="button" v-if="pagination?.next" @click="loadMore" :disabled="loading">Učitaj još komentara</button>			
			</div>
			<div v-else class="no-comments"><BaseCmsLabel code="no_comments" /></div>
		</template>
	</div>
</template>

<script setup>
	const modal = useModal();
	const labels = useLabels();
	const props = defineProps(['item', 'mode']);
	const endpoints = useEndpoints();
	const lang = useLang();

	const loading = ref(false)
	const comments = ref([]);
	const bestReviewedComment = ref(null)
	const selectedSort = ref('');
	const currentPage = ref(1);
	const pagination = ref(null);

	const filters = ref({
		verified: { label: 'Stvarni kupci', query: 'verified_users_only=1', active: false },
		media: { label: 'Foto/video', query: 'with_media=1', active: false },
	});

	const queryOptions = computed(() => {
		const queryParts = Object.entries(filters.value).filter(([_, filter]) => filter.active).map(([_, filter]) => filter.query);

		if (selectedSort.value) {
			queryParts.push(`sort=${selectedSort.value}`);
		}

		queryParts.push(`page=${currentPage.value}`);

		return '?' + queryParts.join('&');
	});

	function toggleFilter(filterKey) {
		filters.value[filterKey].active = !filters.value[filterKey].active;
		currentPage.value = 1;
		fetchComments();
	}

	function sort() {
		currentPage.value = 1;
		fetchComments();
	}

	function loadMore() {
		if (pagination.value?.next) {
			currentPage.value = pagination.value.next;
			fetchComments(true);
		}
	}	

	async function fetchComments(append = false) {
		loading.value = true;
		
		let ep = endpoints.get('_get_hapi_feedback_comments');
		ep = ep.replace('%CONTENT_TYPE%', 'catalogproduct').replace('%ID%', props.item.id).replace('%LANG%', lang.get())+queryOptions.value;
		const res = await useApi(
			ep,
			{method: 'GET'}
		);

		if (res.success) {
			if(!bestReviewedComment.value){
				bestReviewedComment.value = res.data.items.reduce((max, comment) => {
					return comment.review > max.review ? comment : max;
				}, res.data.items[0]);
			}

			if (append) {
				comments.value.push(...res.data.items);
			} else {
				comments.value = res.data.items;
			}

			pagination.value = res.data.meta_data.pagination.page ? res.data.meta_data.pagination.page : null;

		}
		loading.value = false;
	}


	//comments form images & video
	const images = ref({});
	const imageInput = ref({});

	const video = ref({});
	const videoInput = ref({});

	const handleImageChange = (event) => {
		let files = Array.from(event.target.files)
		images.value = files.slice(0, 5)
	}

	function clearImages() {
		images.value = {};		
		imageInput.value[0].value = '';
	}

	function clearVideo() {		
		video.value = {};	
		videoInput.value[0].value = '';
	}
	//comments form images & video

	onMounted(() => {      
		if(props.item?.feedback_comment_widget?.comments > 0 && props.item?.feedback_comment_widget?.model == 'catalogproduct'){			
			fetchComments();        
		}
	})
</script>

<style lang="less" scoped>
	//GENERAL
	.comments-general-cnt{
		position: relative; margin-bottom: 16px;
		@media (max-width: @t){margin-bottom: 10px;}
		@media (max-width: @m){margin-bottom: 14px;}
	}
	.comments-general-rates-grade{
		display: flex; align-items: center;
		:deep(.cp-rate){
			justify-content: flex-start; margin-left: 10px; padding: 0;
			span{
				width: 26px; height: 26px;
				&:after{width: 26px; height: 26px;}
			}
			@media (max-width: @t){
				margin-left: 8px; padding-bottom: 3px;
				span{
					width: 22px; height: 22px;
					&:after{width: 22px; height: 22px;}
				}
			}
			@media (max-width: @m){
				margin-left: 8px; padding-bottom: 3px;
				span{
					width: 22px; height: 22px;
					&:after{width: 22px; height: 22px;}
				}
			}
		}
	}
	.comments-general-grade{
		font-size: 32px; line-height: 40px; font-weight: bold; margin-top: 2px;
		@media (max-width: @t){font-size: 26px; line-height: 32px; margin-top: 3px;}
		@media (max-width: @m){font-size: 24px;}
	}
	.comments-general-counter{
		font-size: 18px; line-height: 22px; font-weight: normal;
		@media (max-width: @t){font-size: 16px; line-height: 20px;}
		@media (max-width: @m){font-size: 14px; line-height: 18px;}
	}
	.comments-titles{
		font-size: 20px; line-height: 26px; font-weight: bold; padding: 8px 0;
		@media (max-width: @t){font-size: 18px; line-height: 22px;}
		@media (max-width: @m){padding: 10px 0; font-size: 16px;}
	}
	.comment-button{
		width: 100%; margin: 16px 0; cursor: pointer;
		@media (max-width: @t){margin: 10px 0;}
		@media (max-width: @m){margin: 14px 0 8px;}
	}

	//FILTERS
	.comments-filters{
		display: flex; align-items: center; justify-content: center; margin: 0 0 16px; gap: 10px; position: relative;
		&.loading{
			:deep(.lds-ring-cnt){position: absolute; left: 50%; margin-left: -10px;}
			.comment-filter, select{pointer-events: none; opacity: 0.1;}
		}
		@media (max-width: @t){gap: 8px; margin-bottom: 10px;}
		@media (max-width: @tp){flex-wrap: wrap;}
		@media (max-width: @m){margin-bottom: 0; padding-bottom: 8px;}
	}
	.comment-filter{
		min-height: 60px; padding: 0 25px; display: flex; align-items: center; justify-content: space-between; border: 1px solid var(--borderColor); font-size: 18px; line-height: 23px; font-weight: normal; flex: 1 1 33%; border-radius: 2px; cursor: pointer; .transition(border-color);
		.slider{
			position: relative; display: block; width: 40px; height: 26px; border-radius: 15px; background: #F0F0F0; transition: background-color 0.3s ease-in-out;
			&:after{.pseudo(20px,20px); left: 3px; top: 3px; border-radius: 200px; background: #fff; z-index: 10; box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.2); .transition(left);}
		}
		&:hover{border-color: var(--textColor);}
		&.active{
			border-color: var(--primaryColor);
			.slider{
				background-color: var(--primaryColor);
				&:after{left: calc(~"100% - 23px");}
			}
		}
		@media (max-width: @l){padding: 0 20px;}
		@media (max-width: @t){height: 50px; min-height: 50px; font-size: 16px;}
		@media (max-width: @tp){flex: 1 1 calc(100%/2 - 4px);}
		@media (max-width: @m){
			padding: 0 15px;
			.slider{
				width: 34px; height: 22px;
				&:after{width: 16px; height: 16px; }
			}
			&.active{
				.slider{
					&:after{left: calc(~"100% - 19px");}
				}
			}
		}
	}
	select{
		width: unset; flex: 1 1 33%;
		@media (max-width: @tp){width: 100%; flex: 1 1 100%;}
		@media (max-width: @m){height: 50px; font-size: 16px;}
	}

	.comments-titles-other{
		padding-top: 16px;
		@media (max-width: @t){margin-top: 10px;}
	}
	
	
	//MODAL
	.publish-comments{
		padding: 0;
		:deep(.base-modal){
			@media (max-width: @m){align-items: flex-end; padding: 0;}
		}
		:deep(.base-modal-cnt){
			width: 596px; max-height: 90vh; overflow-y: auto;
			@media (max-width: @m){width: 100vw; max-width: 100vw; border-radius: 0; box-shadow: 0 -5px 20px 0 rgba(85, 41, 122, 0.5);}
		}
		:deep(.base-modal-cnt-close){
			top: 8px; right: 8px; width: 44px; height: 44px; border-radius: 2px;
			svg{display: none;}
			@media (max-width: @m){
				width: 28px; height: 28px; top: 12px; right: 16px;
				&:before{width: 28px; height: 28px; font-size: 12px; line-height: 12px;}
			}
		}
	}
	.publish-comments.pd{border-top: 0!important;}
	.comment-form-container{
		padding: 40px 48px 48px;
		@media (max-width: @t){padding: 35px;}
		@media (max-width: @m){padding: 16px 16px 19px;}
	}
	.cd-comments-intro{
		font-size: 24px; font-weight: bold; padding-bottom: 12px; color: var(--primaryColor);
		@media (max-width: @tp){font-size: 18px;}
	}
	.comment-form-inner{
		label{top: 21px;}
		.ffl-floated{
			label{top: 5px;}
		}
		@media (max-width: @t){
			label{top: 13px;}
			.ffl-floated{
				label{top: 3px;}
			}
		}
		@media (max-width: @m){
			:deep(.field){
				padding-bottom: 8px;
				input{height: 50px; font-size: 16px;}
			}
			label{top: 16px; font-size: 16px;}
			.ffl-floated{
				label{top: 4px; font-size: 12px;}
			}
		}
	}
	:deep(.comment-field-rate){
		margin: 12px 0 22px;
		.label{font-weight: normal;}
		input[type=radio] + label{
			margin: 2px; width: 22px; height: 22px;
			&:after{width: 22px; height: 22px;}
		}
		@media (max-width: @m){
			margin: 6px 0 16px;
			.label{font-size: 16px; padding-top: 4px;}
			input[type=radio] + label{
				margin: 1px; width: 18px; height: 18px;
				&:after{width: 18px; height: 18px;}
			}
		}
	}
	:deep(.comment-field-images){
		flex-grow: 0; flex-shrink: 0; position: relative; cursor: pointer; padding-bottom: 29px;
		label{
			position: absolute; width: calc(~"100% - 2px"); height: 58px; top: 1px; left: 1px!important; background: #fff; display: flex; align-items: center; padding: 0 25px 0 56px; font-size: 18px; line-height: 23px; justify-content: space-between; cursor: pointer;
			span{font-size: 14px; line-height: 18px; color: var(--textColor); opacity: .6;}
			&:before{.pseudo(24px,21px); .icon-images(); font: 21px/21px var(--fonti); left: 25px;}
		}
		@media (max-width: @t){
			padding-bottom: 23px;
			label{height: 48px; top: 1px; padding-right: 20px;}
		}
		@media (max-width: @m){
			width: 100%; padding-bottom: 25px!important;
			input{height: 50px;}
			label{
				height: 48px; top: 1px!important; left: 1px!important; padding: 0 16px 0 44px!important; font-size: 16px; line-height: 22px;
				&:before{width: 18px; height: 18px; font-size: 18px; line-height: 18px; left: 16px;}
			}
		}
	}
	:deep(.comment-field-video){
		flex-grow: 0; flex-shrink: 0; position: relative; cursor: pointer; padding-bottom: 29px;
		label{
			position: absolute; width: calc(~"100% - 2px"); height: 58px; top: 1px; left: 1px!important; background: #fff; display: flex; align-items: center; padding: 0 25px 0 56px; font-size: 18px; line-height: 23px; justify-content: space-between; cursor: pointer;
			span{font-size: 14px; line-height: 18px; color: var(--textColor); opacity: .6;}
			&:before{.pseudo(22px,24px); .icon-video(); font: 22px/22px var(--fonti); left: 26px;}
		}
		@media (max-width: @t){
			padding-bottom: 23px;
			label{height: 48px; top: 1px; padding-right: 20px;}
		}
		@media (max-width: @m){
			width: 100%; padding-bottom: 25px!important;
			input{height: 50px;}
			label{
				height: 48px; top: 1px!important; left: 1px!important; padding: 0 16px 0 44px!important; font-size: 16px; line-height: 21px;
				&:before{width: 18px; height: 18px; font-size: 18px; line-height: 18px; left: 16px;}
			}
		}
	}
	
	.field-s-note{
		position: absolute; top: 62px; display: block; width: 100%; text-align: right; font-size: 12px; line-height: 18px; color: var(--textColor); opacity: .6; padding: 0 25px;
		@media (max-width: @t){padding-right: 20px; top: 52px;}
		@media (max-width: @m){padding: 2px 16px 0;}
	}
	.uploaded-images{
		position: relative; display: flex; flex-flow: column; align-items: flex-start; justify-content: flex-start; padding: 15px 25px 0; gap: 10px;
		@media (max-width: @m){padding: 12px 16px 0; gap: 10px;}
	}
	.uploaded-images-items{
		display: flex; flex-flow: column; align-items: flex-start; justify-content: flex-start; font-size: 14px; line-height: 18px; text-decoration: underline; text-underline-offset: 2px;
		@media (max-width: @m){font-size: 12px; line-height: 16px;}
	}
	.uploaded-delete{
		position: relative; font-size: 12px; line-height: 17px; padding-left: 15px; cursor: pointer; text-transform: uppercase; color: var(--red); text-decoration: underline; text-underline-offset: 3px; font-weight: 900;
		&:before{.pseudo(auto,auto); .icon-close; font: 10px/10px var(--fonti);  top: 4px; left: 0;}
		&:hover{text-decoration: none;}
	}

	:deep(.comment-field-message) textarea{height: 104px;}
	.comment-button-cnt{
		@media (max-width: @m){flex-flow: column;}
	}
	.btn-send-comment{
		min-width: 160px; font-weight: bold;
		@media (max-width: @m){width: 100%; height: 50px; font-size: 16px;}
	}
	.comment-form-note{
		display: flex;
		@media (max-width: @m){padding: 0 19px; justify-content: center;}
	}
	.comments-load-more{
		margin: 20px 0 20px;
		@media (max-width: @m){margin: 15px 0;}
	}

	//COMMENT REPLAY
	.comment-child{
		padding: 16px 16px 12px; border: 0; background: #F5F5F5; margin-bottom: -1px; position: relative; z-index: 1;
		&:before{.pseudo(24px,24px); background: #F5F5F5; right: 51px; top: -5px; .rotate(45deg); z-index: -1;}
		@media (max-width: @m){
			padding: 12px;
			&:before{right: 65px; top: -3px;}
			:deep(.comment-header){margin-bottom: 4px;}
			:deep(.comment-date){width: unset; margin-left: auto; margin-top: 0;}
		}
	}
</style>